import reducers_ from "./containers/combinedReducer";
import { createLogger } from "redux-logger";
import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import storage from "redux-persist/es/storage";
import { persistCombineReducers } from "redux-persist";

// Log Redux actions only in development: the state holds the signed-in
// user's data and token, which must not be printed in production.
const middleware = [ReduxThunk];
if (process.env.NODE_ENV === "development") {
  middleware.push(createLogger({ collapsed: true }));
}

const config = {
  key: "_parenting_illumine",
  storage
};
const reducers = persistCombineReducers(config, reducers_);

let store = createStore(reducers, {}, applyMiddleware(...middleware));

export default store;